import { createContext, useContext } from 'react';

export const GridColumnContext = createContext(0);
export const useGridColumn = () => useContext(GridColumnContext);
